<template>
  <v-dialog
    :value="open"
    persistent
    :max-width="450"
    @keydown.esc="$emit('update:open', false)"
    @click:outside="$emit('update:open', false)"
  >
    <v-card :min-height="670">
      <div class="px-16 pt-6">
        <span class="icon-hero">
          <v-icon
            class="ma-auto"
            color="primary"
            size="36"
          >
            $faHome
          </v-icon>
        </span>
        <v-card-title class="modal-title">
          Address Confirmation
        </v-card-title>
        <v-card-text
          id="modal-body-text"
          style="padding-left:10px;"
        >
          <v-radio-group
            v-model="addressSelection"
            active-class="active-address"
          >
            <p class="font-weight-bold mb-1">
              Use original address:
            </p>
            <v-radio
              class="address-selection"
              on-icon="$faCheckCircle"
              off-icon="$faCircleRegular"
              value="original"
            >
              <template v-slot:label>
                <div
                  class="d-flex flex-column"
                  :class="addressSelection === 'original' ? 'active' : 'inactive'"
                >
                  <span>{{ originalAddress.street1 }}</span>
                  <span v-if="originalAddress.street2 !== ''">{{ originalAddress.street2 }}</span>
                  <span>{{ originalAddress.city }}, {{ originalAddress.region }} {{ originalAddress.postalcode }}</span>
                  <span>{{ originalAddress.country }}</span>
                </div>
              </template>
            </v-radio>
            <p class="font-weight-bold mb-1 mt-4">
              Suggested Address
            </p>
            <v-radio
              class="address-selection"
              on-icon="$faCheckCircle"
              off-icon="$faCircleRegular"
              value="suggested"
            >
              <template v-slot:label>
                <div
                  class="d-flex flex-column"
                  :class="addressSelection === 'suggested' ? 'active' : 'inactive'"
                >
                  <span>{{ suggestedAddress.street1 }}</span>
                  <span v-if="suggestedAddress.street2 !== ''">{{ suggestedAddress.street2 }}</span>
                  <span>{{ suggestedAddress.city }}, {{ suggestedAddress.region }} {{ suggestedAddress.postalcode }}</span>
                  <span>{{ suggestedAddress.country }}</span>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-card-text>
        <div
          class="d-flex flex-column justify-center mx-auto"
          style="max-width:162px;"
        >
          <v-btn
            color="primary"
            block
            @click="handleAddressSelection"
          >
            Use Selected
          </v-btn>
          <v-btn
            class="ml-0 mt-2 mb-6"
            color="secondary"
            block
            @click="$emit('close-modal')"
          >
            Cancel
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'AddressVerificationModal',
    model: {
      prop: 'open',
      event: 'update:open',
    },
    props: {
      open: {
        type: Boolean,
        default: false,
      },
      originalAddress: Object,
      suggestedAddress: Object,
    },
    data: () => ({
      addressSelection: 'suggested',
    }),
    methods: {
      handleAddressSelection () {
        const chosenAddress = this.addressSelection === 'original' ? this.orginalAddress : this.suggestedAddress
        this.$emit('handle-address-selection', chosenAddress)
      },
    },
  }
</script>

<style lang="scss">
.icon-hero {
  display: flex;
  background-color: $secondary;
  border-radius: 100px;
  text-align: center;
  width: 83px;
  height: 83px;
  padding: 15px;
  margin: 9px auto 2px auto;
}
.btn-container {
  display: flex;
}
.align-actions {
  display: inline-block;
  margin: 3px auto 0 auto;
  padding: 15px 8px 8px 8px;
  text-align: center;
  & > button + button {
    margin: 17px 0 0 0;
  }
}
.modal-title {
  line-height: 30px;
  font-size: 22px;
  letter-spacing: 1px;
  font-weight: 600 !important;
  color: #{$base};
  white-space: nowrap;
  text-align: left !important;
  padding-left: 10px !important;
}
#modal-body-text {
  line-height: 20px;
  padding: 2px 0 20px 0;
  color: #2b394e;
}
.active-address {
  background-color: $primary !important;
  .v-input--selection-controls__input{
    span.v-icon.primary--text {
      color:white !important;
    }

  }
}
.v-input--radio-group__input {
  .v-radio.address-selection {
    background-color: #f9f7f3;
    width: 300px;
    border-radius: 4px;
    box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.25);
    padding: 15px;
    font-size: 15px;
    .active {
        color: white;
    }
    .inactive {
        color: #3C3333;
    }
  }
}
</style>
